import React from "react";
import {Menu} from '@headlessui/react'
import {useTranslation} from "react-i18next";

export type LanguageValue = 'PLN' | 'ENG';

export const LanguageSelector = () => {
    const { i18n } = useTranslation(); // not passing any namespace will use the defaultNS (by default set to 'translation')

    const [language, setLanguage] = React.useState<LanguageValue>('PLN');
    const languages: { code: LanguageValue, name: string }[] = [
        {code: 'PLN', name: 'Polish'},
        {code: 'ENG', name: 'English'},
    ];

    const languageFlagMap: Record<LanguageValue, string> = {
        PLN: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Flag_of_Poland.svg/1280px-Flag_of_Poland.svg.png?20180824112544',
        ENG: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/1280px-Flag_of_the_United_States.svg.png?201807031501',
    }

    const languageCodeMap: Record<LanguageValue, string> = {
        PLN: 'pl',
        ENG: 'en',
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button>
                    <div className="hidden lg:ml-8 lg:flex">
                        <a href="#" className="flex items-center text-gray-700 hover:text-gray-800">
                            <img
                                alt=""
                                src={languageFlagMap[language]}
                                className="block h-auto w-5 shrink-0"
                            />
                            <span className="ml-3 block text-sm font-medium">{language}</span>
                            <span className="sr-only">, change currency</span>
                        </a>
                    </div>
                </Menu.Button>
            </div>

            <Menu.Items
                className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
                <div className="py-1">
                    {languages.map((lang) => (
                        <Menu.Item key={lang.code}>
                            <a
                                onClick={() => {
                                    setLanguage(lang.code);
                                    i18n.changeLanguage(languageCodeMap[lang.code]).then(r => console.log(r));
                                }}
                                href="#"
                                className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                            >
                                {lang.name}
                            </a>
                        </Menu.Item>
                    ))}
                </div>
            </Menu.Items>
        </Menu>
    )
}